@if (node() && editable && formGroup()) {
<div class="folder-panel">
    <form class="folder-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden">
                    <a class="tab-link" (click)="onClick(tab)" [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a>
                </li>
                }
            </ul>
        </div>
        <div class="body">
            @if (node()?.prototypeId) {
            <div class="row key" [hidden]="tabSelected != tabFolder">
                <app-graphql-checker [formGroup]="formGroup()!" [model]="node()!.graphqlType" [validate]="validate" [meta]="metaGraphql"></app-graphql-checker>
            </div>
            }
            <div class="row" [hidden]="tabSelected != tabFolder">
                <div class="folder-info">
                    Folder Name: {{node()!.name}}
                </div>
                @if (node()?.prototypeId) {
                <div class="folder-info">
                    For Prototype: {{node()?.prototype?.name ? node()!.prototype!.name : 'No prototype defined.'}}
                </div>
                }
                @if (node()?.prototypeId) {
                <div class="folder-aspect">
                    <app-aspect-picker [formGroup]="formGroup()!" [meta]="metaAspect" [model]="node()!.aspects" [lockModel]="node()!.inheritAspects" [node]="node()!" groupBy="parent.name">
                    </app-aspect-picker>
                </div>
                <div class="folder-attribute">
                    <app-aspect-picker [formGroup]="formGroup()!" [meta]="metaAttribute" [model]="node()!.attributes" [lockModel]="node()!.inheritAttributes" [node]="node()!" groupBy="parent.name" (change)="onChange($event)">
                    </app-aspect-picker>
                </div>
                }
            </div>
            @if (node()?.prototypeId) {
            @if (contentModel()) {
            <div class="row attribute" [hidden]="tabSelected != tabAttribute">
                <app-content [tags]="contentModel()!.tags" [custome]="model().custome" [formGroup]="formData" [node]="node()" [readonly]="model().readonly"></app-content>
            </div>
            }
            <div class="row preview" [hidden]="tabSelected != tabPreview">
                <app-preview [formGroup]="formGroup()!" [node]="node()"></app-preview>
            </div>
            <div class="row publish" [hidden]="tabSelected != tabPublish">
                <app-publish [formGroup]="formGroup()!" [node]="node()"></app-publish>
            </div>
            <div class="row import" [hidden]="tabSelected != tabImport">
                <app-import [formGroup]="formGroup()!" [model]="node()!.import" [status]="model().custome._import"></app-import>
            </div>
            }
            @if (permissible) {
            <div class="row security" [hidden]="tabSelected != tabSecurity">
                <div class="folder-info">
                    <app-security [permission]="permission()" [formGroup]="formPermission" [readonly]="node()!.isNew"></app-security>
                </div>
            </div>
            }
            @if (permissible) {
            <div class="row access" [hidden]="tabSelected != tabAccess">
                <div class="folder-info">
                    <app-access [admission]="admission()" [formGroup]="formAdmission" [readonly]="node()!.isNew"></app-access>
                </div>
            </div>
            }
        </div>
        <div class="footer">
            <div class="row">
                @if (tabSelected != tabSecurity && tabSelected != tabAccess) {
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
                }
                @if (tabSelected === tabImport && !node()!.isNew) {
                <button type="button" class="button button-big" [disabled]="!enableEndpoint" (click)="onRequest()">
                    <mat-icon class="regular-icon">download_for_offline</mat-icon>
                </button>
                }
                @if (tabSelected === tabImport && !node()!.isNew) {
                <button type="button" class="button button-big" [disabled]="!enableCast" (click)="onConvert()">
                    <mat-icon class="regular-icon">file_copy</mat-icon>
                </button>
                }
                @if (tabSelected === tabImport && !node()!.isNew) {
                <button type="button" class="button button-big" [disabled]="!enableImport" (click)="onImport()">
                    <mat-icon class="regular-icon">update</mat-icon>
                </button>
                }
                @if (tabSelected === tabSecurity) {
                <button type="button" class="button button-big" [disabled]="!formPermission.dirty"
                    (click)="onPermission()">
                    <mat-icon class="regular-icon">lock</mat-icon>
                </button>
                }
                @if (tabSelected === tabSecurity) {
                <button type="button" class="button button-big" [disabled]="node()!.isNew" (click)="onCascade()">
                    <mat-icon class="regular-icon">move_down</mat-icon>
                </button>
                }
                @if (tabSelected === tabAccess) {
                <button type="button" class="button button-big" [disabled]="!formAdmission.dirty"
                    (click)="onAdmission()">
                    <mat-icon class="regular-icon">vpn_key</mat-icon>
                </button>
                }
            </div>
        </div>
    </form>
</div>
}
